import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import AccountingUserName from "../../components/accountingUser/AccountingUserDetail/AccountingUserName.tsx";
import {useLocationFormState} from "../../components/accountingUser/AccountingUserForm/AccountingUserUpdateForm";
import AccountingUserUpdateFormProvider from "../../components/accountingUser/AccountingUserForm/AccountingUserUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const AccountingUserUpdateEditPage = () => {
    
    useTitle(t`Update Accounting User`);

    const { accountingUserId: id } = useParams();
    
    return (
        <Box data-testid="AccountingUser-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="AccountingUser-update-title"
                    >
                        <Trans>Edit Accounting User</Trans>:  <AccountingUserName id={id}/>
                    </Typography>
                    <AccountingUserUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default AccountingUserUpdateEditPage;
